module.exports = __webpack_public_path__ + "static/media/sp3.e33a850b.jpg";